import { AdaButton } from '@betrybe/ada-react';
import type { ReactElement, ReactNode } from 'react';

type InfoGroupType = {
  title: ReactNode;
  description: ReactNode;
  buttonName: string;
  handleClick: () => void;
};

function InfoGroup(props: InfoGroupType): ReactElement {
  const { title, description, buttonName, handleClick } = props;
  return (
    <div className="infogroup-container">
      <h1 className="infogroup-container__info-title">{title}</h1>
      <p>{description}</p>
      <div>
        <AdaButton onClick={handleClick}>{buttonName}</AdaButton>
      </div>
    </div>
  );
}

export default InfoGroup;
